import { styled } from '@mui/material/styles';

export const ViewRoot = styled('div')({
    position: 'fixed',
    width: '100%',
    height: '100%',
    overflow: 'hidden',
});